<template>
  <div class="dko-index-toolbar">
    <v-text-field
      v-model="searchPhrase"
      class="dko-index-toolbar__search searchbox-input mr-2"
      persistent-hint
      background-color="white"
      hide-details
      clearable
      placeholder="Wyszukaj"
      v-bind="props.shortTextField"
      prepend-inner-icon="mdi-magnify"
      @keyup="search"
      @click:clear="search"
    />

    <v-select
      :value="listQuery.purpose"
      :items="purposes"
      item-value="id"
      item-text="label"
      placeholder="Cel przekazania materiału"
      clearable
      v-bind="props.select"
      class="mr-2 width-220"
      @input="apply({ purpose: $event })"
    />

    <v-select
      :value="listQuery.departmentId"
      :items="filtersOptions.departments"
      item-value="id"
      item-text="name"
      placeholder="Oddział"
      clearable
      v-bind="props.select"
      class="mr-2 width-140"
      @input="apply({ departmentId: $event })"
    >
      <template #selection="{ item }">
        {{ item.shortcut }}
      </template>
    </v-select>

    <v-btn
      v-if="createPermitted"
      depressed
      color="primary"
      :to="{ name: 'create-dko' }"
    >
      Nowy wniosek
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import debounce from 'lodash.debounce';
import props from '@/helpers/componentsProps';

export default {
  data() {
    return {
      props,
      searchPhrase: this.$store.state.dkoCooperation.listQuery.query || '',
    };
  },
  computed: {
    ...mapState('filters', ['filtersOptions']),
    ...mapState('dkoCooperation', ['listQuery']),
    ...mapGetters('auth', ['checkUserPermissions']),
    createPermitted() {
      return this.checkUserPermissions([
        'admin_director',
        'chief',
        'department_director',
        'user',
        'graphic',
        'editor',
        'project_manager',
        'print_coordinator',
      ]);
    },
    purposes() {
      return this.filtersOptions.dkoCooperationRequestPurposes || [];
    },
  },
  methods: {
    ...mapActions('dkoCooperation', ['setListQuery']),
    apply(query) {
      this.setListQuery(query);
    },
    search: debounce(function search() {
      this.apply({ query: this.searchPhrase });
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
.dko-index-toolbar {
  display: flex;
  position: relative;

  &__search {
    width: 172px;
    @include desktop {
      width: 280px;
    }
  }
}
</style>
